import * as Actions from "./actions";
import * as Path from './apiRoutes';
import ApiService from "../../../../utils/apiService";
import { MSG_DEFAULT_ERROR } from "../../../../utils/messages";
import { NOTIF_ERROR, DATE_TIME_FORMAT, DATE_FORMAT, YEAR_FORMAT } from "../../../../utils/constants";
import { SideNotification } from "../../../../utils/common";
import { REST_COUNTRIES } from "../../../../config/settings"
import moment from 'moment';
import countries from '../../../../utils/Countries.json';


export const getMemberList = (params) => (dispatch) => {
    return ApiService.list(Path.MEMBER_ROOT, params)
        .then((response) => {
            dispatch(Actions.setList(response.data.data.memberList.list));
            return response.data;
        })
        .catch((error) => {
            SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR)
        })
};

export const getIndustryList = () => (dispatch) => {
    return ApiService.get(Path.MEMBER_ROOT + `/list/industry`)
        .then((response) => {
            dispatch(Actions.setIndustryList(response.data.data));
            return response.data;
        })
        .catch((error) => {
            SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR)
        })
};

export const updateMemberPrimaryUser = (id) => () => {
    return ApiService.post(Path.MEMBER_ROOT + `/insert/${id}/member`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR)
        })
};

export const listOfCountries = () => () => {
    return countries
}

export const insertMember = (userDetails, imageFile, imageProofFile) => () => {

    userDetails.isOfficer = userDetails.isOfficer ? "1" : "0"
    userDetails.adminRights = userDetails.superAdminRights ? "2" : userDetails.adminRights ? "1" : "0";
    userDetails.industryId = Number(userDetails.industryId)
    userDetails.authUsername = userDetails.emailAddress
    userDetails.birthdate = moment(userDetails.birthdate).format(DATE_FORMAT)
    userDetails.batchYear = moment(userDetails.batchYear).format(YEAR_FORMAT)
    userDetails.subscriptionStartDate = moment(userDetails.startDate)
    userDetails.subscriptionEndDate = moment(userDetails.endDate)
    const params = new FormData();
    userDetails = Object.keys(userDetails).filter(key => "startDate" !== key && "endDate" !== key && "superAdminRights" !== key).reduce((obj, key) => { obj[key] = userDetails[key]; return obj; }, {});

    params.append("userDetails", JSON.stringify(userDetails));
    params.append("imageFile", imageFile);
    params.append("paymentImageFile", imageProofFile);
    return ApiService.insert(Path.MEMBER_ROOT, params)
        .then((response) => {
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
};



export const updateMember = (userDetails, imageFile, imageProofFile) => (dispatch) => {

    userDetails.isOfficer = userDetails.isOfficer ? "1" : "0"
    userDetails.adminRights = userDetails.superAdminRights ? "2" : userDetails.adminRights ? "1" : "0";
    userDetails.industryId = Number(userDetails.industryId)
    userDetails.authUsername = userDetails.emailAddress
    userDetails.birthdate = moment(userDetails.birthdate).format(DATE_FORMAT)   
    userDetails.subscriptionStartDate = moment(userDetails.startDate)
    userDetails.subscriptionEndDate = moment(userDetails.endDate)
    userDetails.batchYear = moment(userDetails.batchYear).format(YEAR_FORMAT)

    const params = new FormData();
    userDetails = Object.keys(userDetails).filter(key => "startDate" !== key && "endDate" !== key && "superAdminRights" !== key).reduce((obj, key) => { obj[key] = userDetails[key]; return obj; }, {});

    params.append("userDetails", JSON.stringify(userDetails));
    params.append("imageFile", imageFile);
    params.append("paymentImageFile", imageProofFile);
    return ApiService.update(Path.MEMBER_ROOT, params)
        .then((response) => {
            dispatch(getMemberById(userDetails.userId))
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
};


export const getMemberById = (id) => (dispatch) => {
    return ApiService.get(Path.MEMBER_ROOT + `/${id}`)
        .then((response) => {
            dispatch(Actions.setMember(response.data.data));
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
};

export const deleteMember = (id) => () => {
    return ApiService.delete(Path.MEMBER_ROOT, id)
        .then((response) => {
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
};

export const exportMembers = () => () => {
    return ApiService.get(Path.MEMBER_ROOT + "/export", { responseType: "blob" })
        .then((response) => {
            var blob = new Blob([response.data], {type: 'application/vnd.ms-excel'});
            var downloadUrl = URL.createObjectURL(blob);
            var a = document.createElement("a");
            a.href= downloadUrl;
            a.download = ("Member - " + moment().format(DATE_TIME_FORMAT) + ".xlsx");
            a.click();
            return response;
        }).catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
}

export const renewMembership = (renewDetails, imageProofFile) => (dispatch) => {

    const params = new FormData();
    renewDetails = Object.keys(renewDetails).filter(key => "startDate" !== key && "endDate" !== key).reduce((obj, key) => { obj[key] = renewDetails[key]; return obj; }, {});
    renewDetails.subscriptionEndDate = moment(renewDetails.subscriptionEndDate)
    renewDetails.paymentDate = moment(renewDetails.paymentDate)
    params.append("renewDetails", JSON.stringify(renewDetails));
    params.append("paymentImageFile", imageProofFile);
    return ApiService.post(Path.MEMBER_ROOT + "/renew", params)
        .then((response) => {
            dispatch(getMemberById(renewDetails.memberId))
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
};

